import { Helmet } from "react-helmet-async";
import { useIntl } from "react-intl";

import AppPage from "@components/pageTypes/AppPage";
import PageTitle from "@components/text/PageTitle";

const ExpertAccountPage = () => {
  const intl = useIntl();

  return (
    <AppPage>
      <Helmet>
        <title>{intl.formatMessage({ id: "pageTitles.expert.account.show" })}</title>
      </Helmet>
      <PageTitle imageName="peopleCoffeeLight" titleKey="pages.expert.account.title" />
    </AppPage>
  );
};

export default ExpertAccountPage;
